
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/amplitude",
      function () {
        return require("private-next-pages/destinations/amplitude.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/amplitude"])
      });
    }
  